import script from "./number.vue?vue&type=script&lang=ts&setup=true"
export * from "./number.vue?vue&type=script&lang=ts&setup=true"

import "./number.vue?vue&type=style&index=0&id=1b5be2a2&scoped=true&lang=less"

import exportComponent from "/Users/user/Projects/simweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b5be2a2"]])

export default __exports__